define('uikit/behaviors/hide.when.collection.empty.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _  = require('underscore');
  var Mn = require('marionette');


  var HideWhenCollectionEmptyBehavior = Mn.Behavior.extend({

    onFirstBeforeRender: function() {
      var collection = this.getOption('collection') || this.view.collection;
      if (collection) {
        this.listenTo(collection, 'update reset', function() {
          this.updateVisibilityFromCollection(collection);
        });
        this.updateVisibilityFromCollection(collection);
      }
    },

    updateVisibilityFromCollection: function(collection) {
      this.view.visible = collection.length > 0;
    }

  });
  module.exports = HideWhenCollectionEmptyBehavior;
});

